import { connect } from 'react-redux';
import OrderDashboard from '../components/OrderDashboard/OrderDashboard';
import { getUser } from '../redux/actions/AccountSetting';
import { getPersonLeadNoteStatus, getPersonQrCodeStatus } from '../redux/actions/CurrentPersonStatus';
import { push } from 'react-router-redux';

const mapStateToProps = (state) => ({
  routerInfo: state.router.location,
  user: state.accountSetting.user,
  isDemo: state.accountSetting.showDemoData,
  isProxyLoginLoading: state.accountSetting.isProxyLoginLoading,
  // [リード情報獲得]
  isLoadingLeadNote: state.currentPersonStatus.isLoadingLeadNote,
  pageInfoLeadNote: state.currentPersonStatus.pageInfoLeadNote,
  // [QRコードリアクション]
  isLoadingQrCode: state.currentPersonStatus.isLoadingQrCode,
  pageInfoQrCode: state.currentPersonStatus.pageInfoQrCode,
  // [メッセージ]
  successMessage: state.currentPersonStatus.successMessage,
  errorMessage: state.currentPersonStatus.errorMessage,
  shortMessage: state.currentPersonStatus.shortMessage,
})

const mapDispatchToProps = dispatch => ({
  // [QRコードリアクション]
  getPersonQrCodeStatus(data) {
    dispatch(getPersonQrCodeStatus(data))
  },

  // [リード情報獲得]
  getPersonLeadNoteStatus(data) {
    dispatch(getPersonLeadNoteStatus(data))
  },

  getUserInfo() {
    dispatch(getUser());
  },

  goTo(url, state) {
    dispatch(push(url, state));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(OrderDashboard);



// WEBPACK FOOTER //
// ./src/containers/OrderDashboard.js